import { render, staticRenderFns } from "./PosEdit.vue?vue&type=template&id=458e822d&scoped=true"
import script from "./PosEdit.vue?vue&type=script&lang=js"
export * from "./PosEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e822d",
  null
  
)

export default component.exports